const parse = require('./parse')
const valid = (version, options) => {
  const v = parse(version, options)
  return v ? v.version : null
}
module.exports = valid



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/valid.js
// module id = 1929
// module chunks = 1